<footer class="footer w-full mt-12 py-6 flex flex-col items-center gap-2 text-ink-500 text-sm" dir="rtl">
  <h4 class="stamFont text-base text-ink-600">
    כל הזכויות שמורות לבית הכנסת תפארת ישראל, גני צבי
  </h4>
  <p class="text-xs">&copy; {{ year }}</p>
</footer>
